import React from 'react';
import propTypes from 'prop-types';
import styles from './CutPaper.module.scss';

const CutPaper = ({ content, paddingSize, cutPaperPath, heroSubHeader, backgroundColor = '#fff', textColor = '#000', style }) => {
	const cmsStyles = {
		cutPaper: {
			clipPath: cutPaperPath,
			backgroundColor,
			...style,
		},
		contentPadding: {
			padding: paddingSize,
			color: textColor,
		},
	};

	return (
		<div className={styles.container}>
			<div style={cmsStyles.cutPaper}>
				<div style={cmsStyles.contentPadding} className={heroSubHeader && styles.contentContainer}>
					{content}
				</div>
			</div>
		</div>
	);
};

CutPaper.propTypes = {
	content: propTypes.object,
	paddingSize: propTypes.string,
};

export default CutPaper;
